module.exports = __webpack_public_path__ + "img/login.bf739c02.png";